import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import Text from '../../elementals/text'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const SubLabel = ({
  label = '',
  compact = false,
  className = '',
  elmId = 'field',
}) =>
  label && typeof label === 'string' ? (
    <>
      <div className={cx('break')} />
      <Text
        size='tiny'
        color='grayMedium'
        className={cx('sub-label', { compact }, className)}
        data-elm-id={`${elmId}_sublabel`}
      >
        {label}
      </Text>
    </>
  ) : (
    label
  )

SubLabel.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  compact: PropTypes.bool,
  className: PropTypes.string,
  elmId: PropTypes.string,
}

export default SubLabel
